import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppointmentCalendar } from '../../components/appointments/AppointmentCalendar';

export function AppointmentsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
          {t('appointments.title')}
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Gestión completa de citas médicas con calendario interactivo
        </p>
      </div>
      
      <AppointmentCalendar />
    </div>
  );
} 